<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="grid grid-cols-2 gap-4">
    <widget-component>
      <template #content>
        <div class="text-xl font-bold text-secondary">Browser</div>
        <div v-if="hasData('browser')" id="user_agent_browser_chart"></div>
        <div v-else>
          Keine Daten vorhanden
        </div>
      </template>
    </widget-component>

    <widget-component>
      <template #content>
        <div class="text-xl font-bold text-secondary">Betriebssysteme</div>
        <div v-if="hasData('os')" id="user_agent_os_chart"></div>
        <div v-else>
          Keine Daten vorhanden
        </div>
      </template>
    </widget-component>

    <widget-component>
      <template #content>
        <div class="text-xl font-bold text-secondary">Geräte</div>
        <div v-if="hasData('devices')" id="user_agent_device_chart"></div>
        <div v-else>
          Keine Daten vorhanden
        </div>
      </template>
    </widget-component>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useStatisticsStore } from "@/stores/statistics";
import ApexCharts from "apexcharts";
import WidgetComponent from "@/components/WidgetComponent";
import _ from "lodash";

export default {
  name: "UserAgentReportComponent",
  components: { WidgetComponent },
  data() {
    return {
      userAgentsReport: undefined,
      chartOptions: {
        series: [],
        chart: {
          height: "400px",
          type: "donut"
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      },
      charts: []
    };
  },
  computed: {
    ...mapStores(useStatisticsStore)
  },
  mounted() {
    // render charts
    this.browser();
    this.os();
    this.device();
  },
  unmounted() {
    for (const chart of this.charts) {
      chart.destroy();
    }
  },
  methods: {
    browser() {
      if (!this.hasData("browser"))
        return;

      const browserChartOptions = this.clone(this.chartOptions);

      for (const browser of this.statisticsStore.getStatistic.userAgent.browser) {
        browserChartOptions.series.push(browser.count);
        browserChartOptions.labels.push(browser.name);
      }

      const browserChart = new ApexCharts(document.querySelector("#user_agent_browser_chart"), browserChartOptions);
      browserChart.render();
      this.charts.push(browserChart);
    },
    os() {
      if (!this.hasData("os"))
        return;

      const osChartOptions = this.clone(this.chartOptions);

      for (const os of this.statisticsStore.getStatistic.userAgent.os) {
        osChartOptions.series.push(os.count);
        osChartOptions.labels.push(os.name);
      }

      const osChart = new ApexCharts(document.querySelector("#user_agent_os_chart"), osChartOptions);
      osChart.render();
      this.charts.push(osChart);
    },
    device() {
      if (!this.hasData("devices"))
        return;

      const deviceChartOptions = this.clone(this.chartOptions);

      for (const device of this.statisticsStore.getStatistic.userAgent.devices) {
        deviceChartOptions.series.push(device.count);
        deviceChartOptions.labels.push(`${device.name}`);
      }

      const deviceChart = new ApexCharts(document.querySelector("#user_agent_device_chart"), deviceChartOptions);
      deviceChart.render();
      this.charts.push(deviceChart);
    },
    clone(object) {
      return _.cloneDeep(object);
    },
    hasData(field) {
      return this.statisticsStore.getStatistic.userAgent[field]?.length > 0;
    }
  }
};
</script>

<style scoped>

</style>